import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import ProductCatalogTableCell from 'ui-addon-upgrades/_core/productCatalog/ProductCatalogTableCell';
import ProductCatalogTableTitle from 'ui-addon-upgrades/_core/productCatalog/ProductCatalogTableTitle';
const FeatureName = styled.div.withConfig({
  displayName: "MobileSuiteCatalogTableCell__FeatureName",
  componentId: "sc-1x61xao-0"
})(["padding:10px 0;display:inline-block;& > p{margin-left:8px;margin-bottom:0;font-weight:500;display:inline-block;}text-align:left;"]);

const MobileSuiteCatalogTableCell = ({
  productLine,
  productLevel,
  feature
}) => {
  // Q: should this be responsive to window resizing?
  const [width] = useState(window.innerWidth);
  const showTooltip = width >= 800;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("td", {
      className: "p-left-8",
      style: {
        width: '27%'
      },
      children: /*#__PURE__*/_jsx(FeatureName, {
        children: feature && /*#__PURE__*/_jsx(ProductCatalogTableTitle, {
          featureId: feature,
          productLine: productLine,
          showTooltip: showTooltip
        })
      })
    }), /*#__PURE__*/_jsx(ProductCatalogTableCell, {
      featureId: feature,
      productLine: productLine,
      showTooltip: showTooltip,
      allProductLevels: [productLevel],
      currentProductLevel: productLevel,
      hasFeature: true
    })]
  });
};

export default MobileSuiteCatalogTableCell;